export default "__VITE_ASSET__aE73F2ZE__"